import * as yup from 'yup';

import { LC_PAGE_SUBJECT_CHAR_LIMIT } from '@lessonPlanner/constants';

export default yup.object().shape({
  gradeLevel: yup.string().required('Please select a grade level'),
  subject: yup
    .string()
    .required('Please enter a subject')
    .test(
      'len',
      'You have reached the character limit',
      (val: any) => val.length <= LC_PAGE_SUBJECT_CHAR_LIMIT,
    ),
  language: yup.string().required('Please select a translation'),
  format: yup.string().required('Please select a format'),
  objectives: yup.array()
    .of(
      yup.object().shape({
        day: yup.string().required(),
        dayObjectives: yup.lazy(value => {
          // If dayObjectives is null, don't apply any validation (day not added)
          if (value === null) return yup.array().nullable();

          // If dayObjectives is an array (day added), validate it has at least one non-empty objective
          return yup.array()
            .of(yup.string().nullable())
            .test(
              'at-least-one-objective',
              'Please fill out or remove the empty day objectives',
              function(objectives) {
                if (!objectives) return false;
                return objectives.some(obj => obj && obj.trim() !== '');
              }
            );
        })
      })
    )
    .test(
      'at-least-one-day',
      'Please set objectives...',
      function(value) {
        if (!value) return false;
        // Check if at least one day has objectives added
        return value.some(day => day.dayObjectives !== null);
      }
    )
});
